import { colours } from './colours';

const MapLegend = ({ mapMetric = 'total', dynamicScale }) => {
    const isPer100k = mapMetric === 'per100k';
    const scale = isPer100k ? (dynamicScale || colours.SCALE_100K) : colours.SCALE;

    return (
        <div id='legend-container' style={{
            display: 'flex',
            flexDirection: 'column',
            height: 'auto',
            width: 'fit-content',
            alignItems: 'flex-start',
            gap: '6px',
            backgroundColor: 'rgba(255,255,255,0.8)',
            padding: '10px',
            borderRadius: '8px',
            backdropFilter: 'blur(4px)',
            boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
        }}>
            <p style={{ margin: '0 0 4px 0', fontSize: '0.7rem', fontWeight: 'bold', color: '#1a3a63', textTransform: 'uppercase' }}>
                {isPer100k ? 'Outlets per 100k' : 'N Outlets'}
            </p>
            {scale.map((bin, i) => (
                <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <div
                        style={{
                            width: '14px',
                            height: '14px',
                            backgroundColor: bin.color,
                            opacity: 0.8,
                            border: '1px solid rgba(0,0,0,0.1)',
                            borderRadius: '2px'
                        }}
                    />
                    <p className='legend-text' style={{ margin: 0, fontSize: '0.75rem', color: '#333' }}>
                        {bin.label} {!isPer100k && (bin.label === '0' || bin.label === '1' ? 'outlet' : 'outlets')}
                    </p>
                </div>
            ))}
        </div>
    );
}

export default MapLegend